import React, { useCallback } from "react";
import { Switch as ChakraSwitch } from "@chakra-ui/react";
export function Switch({ isDisabled = false, onChange, ...props }) {
    const valueChanged = useCallback((event) => {
        onChange(event.target.checked);
    }, [onChange]);
    return (React.createElement(ChakraSwitch, { isDisabled: isDisabled, onChange: valueChanged, ...props }));
}
